export default "__VITE_ASSET__cc443c3c__"